export const yeuCauXuatHoaDon = {
  titles: {
    list: 'Yêu cầu xuất hóa đơn',
    detail: 'Chi tiết yêu cầu xuất hóa đơn',
    create: 'Tạo yêu cầu xuất hóa đơn',
  },
  sections: {
    list: { title: 'Yêu cầu xuất hóa đơn' },
    commentThread: 'Bình luận',
    pdfViewer: 'Hóa đơn nháp',
    auditLog: 'Lịch sử thay đổi',
    buyerInfo: 'Thông tin người mua',
    transitionBar: 'Hành động',
    chiTietHangHoa: 'Chi tiết hàng hóa',
    thuKhac: 'Thu khác',
    tongKetTien: 'Tổng kết tiền',
    hoaDonChinhThuc: 'Hóa đơn chính thức',
  },
  form: {
    sectionHeader: 'Thông tin chung',
    sectionLines: 'Danh sách hàng xuất hóa đơn',
    nguonTitle: 'Chi tiết hàng hóa đơn',
    nguonTabTong: 'Tổng',
    productSearch: 'Tìm mã / tên hàng',
    tongSoMatHang: 'Số mặt hàng',
    tongSoLuong: 'Tổng số lượng',
    tongTienHang: 'Tổng tiền hàng',
    lineCount: '{count} dòng',
    emptyAddProduct: 'Tìm và chọn hàng hóa phía trên để thêm dòng.',
    emptyAddProductPos: 'Gõ mã / tên hàng trên thanh xanh (F3) để thêm dòng.',
    motKhachNhieuHoaDon:
      'Một yêu cầu có thể gồm nhiều hóa đơn (mỗi công ty một hóa đơn) nhưng chỉ chung một khách. Một đơn nhiều mã hàng vẫn tách được sang nhiều công ty.',
    hoaDonThuTu: 'Hóa đơn {index}',
  },
  fields: {
    maYeuCau: 'Mã yêu cầu',
    qr: 'QR',
    hoaDonGoc: 'Hóa đơn gốc',
    maHoaDonGoc: 'Mã hóa đơn gốc',
    hoaDonNguon: 'Hóa đơn nguồn',
    khachHang: 'Khách hàng',
    maKhachHang: 'Mã khách',
    tenKhachHang: 'Tên khách',
    nhanVienPhuTrach: 'NV KD phụ trách',
    tenCongTyLayThue: 'Tên công ty lấy thuế',
    diaChiLayThue: 'Địa chỉ cty lấy thuế',
    soDienThoai: 'Số điện thoại',
    email: 'Email',
    ghiChu: 'Ghi chú',
    congTyXuatHd: 'Công ty xuất HĐ',
    soLuongTuDo: 'Số lượng nhập tự do, không giới hạn theo hóa đơn gốc',
    tenNguoiMua: 'Tên người mua',
    maSoThue: 'Mã số thuế',
    soMatHang: 'Số SP',
    soTien: 'Số tiền',
    diaChiHoaDon: 'Địa chỉ hóa đơn',
    tinhThanhHoaDon: 'Tỉnh/thành hóa đơn',
    phuongXaHoaDon: 'Phường/xã hóa đơn',
    soCCCD: 'Số CCCD',
    soHoChieu: 'Số hộ chiếu',
    emailHoaDon: 'Email hóa đơn',
    soDienThoaiHoaDon: 'Số điện thoại hóa đơn',
    nganHang: 'Ngân hàng',
    soTaiKhoanNganHang: 'Số tài khoản ngân hàng',
    lyDoXuat: 'Lý do xuất',
    trangThai: 'Trạng thái',
    soLanReject: 'Số lần reject',
    rejectCount: 'Đã reject {count} lần',
    createdAt: 'Ngày tạo',
    createdBy: 'Người tạo',
    updatedAt: 'Ngày cập nhật',
    updatedBy: 'Người cập nhật',
    version: 'Phiên bản',
    uploadedBy: 'Người tải lên',
    uploadedAt: 'Ngày tải lên',
    loaiFile: 'Loại file',
    actions: 'Thao tác',
    anonymousAuthor: '(Ẩn danh)',
    requiredMark: ' (bắt buộc)',
    optionalMark: ' (tùy chọn)',
    hintTextBuyerInfo:
      '3 trường bắt buộc: mã số thuế, tên công ty lấy thuế, địa chỉ cty lấy thuế.',
    // Chi tiết hàng hóa
    maHangHoa: 'Mã hàng',
    tenHangHoa: 'Tên hàng',
    donViTinh: 'ĐVT',
    donViTinhBan: 'ĐVT bán',
    donViTinhCoBan: 'Đơn vị tính cơ bản',
    soLuong: 'Số lượng',
    soLuongBan: 'Số lượng bán',
    soLuongCoBan: 'Số lượng cơ bản',
    donGia: 'Đơn giá',
    donGiaBan: 'Đơn giá bán',
    giamGiaBan: 'Giảm giá bán',
    giaBan: 'Giá bán',
    giaBanCoBan: 'Giá bán cơ bản',
    thanhTien: 'Thành tiền',
    thanhTienBan: 'Thành tiền bán',
    thanhTienCoBan: 'Thành tiền cơ bản',
    // Khai VAT
    ngayKhaiVat: 'Ngày khai',
    tenKhaiVat: 'Tên khai VAT',
    donViTinhKhaiVat: 'ĐVT khai VAT',
    tyLeBanCoBan: 'Tỷ lệ quy đổi',
    tyLeBanCoBanHint: '1 ĐVT bán = Tỷ lệ × đơn vị tính cơ bản',
    tyLeBanTrenDvt: 'ĐVT bán / ĐVT',
    tyLeBanTrenDvtHint: '1 ĐVT bán = Tỷ lệ × ĐVT',
    tyLeQuyDoi: 'ĐVT khai VAT / ĐVT bán',
    tyLeQuyDoiHint: '1 ĐVT khai VAT = Tỷ lệ × ĐVT bán',
    soLuongXuatVat: 'SL xuất VAT',
    soLuongXuatVatHint: 'Nhập theo ĐVT khai VAT. Mặc định = SL bán ÷ (ĐVT khai VAT / ĐVT bán)',
    donGiaXuatVat: 'Đơn giá xuất VAT',
    donGiaXuatVatHint:
      'Nhập theo ĐVT khai VAT. Mặc định = đơn giá bán × (ĐVT khai VAT / ĐVT bán)',
    donGiaKhaiVat: 'Đơn giá VNĐ khai VAT',
    soLuongTonKhaiVat: 'SL tồn',
    phanTramVat: '% VAT',
    // Thu khác
    tenThuKhac: 'Tên khoản thu',
    giaTri: 'Giá trị',
    phanTram: 'Phần trăm',
    // Tổng kết tiền
    tongTienHang: 'Tổng tiền hàng',
    giamGia: 'Giảm giá',
    tongSauGiamGia: 'Sau giảm giá',
    thuKhac: 'Thu khác',
    thueGtgt: 'Thuế GTGT',
    khachCanTra: 'Khách cần trả',
    khachDaTra: 'Khách đã trả',
    tienThua: 'Tiền thừa',
    soHoaDon: 'Số hóa đơn',
    kyHieuHoaDon: 'Ký hiệu',
    ngayXuatHoaDon: 'Ngày xuất hóa đơn',
    soHoaDonDaXuat: 'Đã xuất HĐ {soHoaDon} · {ngay}',
  },
  filters: {
    maYeuCau: 'Mã yêu cầu',
    maHoaDon: 'Mã hóa đơn',
    soHoaDon: 'Số hóa đơn',
    maSoThue: 'Mã số thuế',
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng / người mua',
    hintSection: 'Bộ lọc YCX',
    hintBody: 'Lọc theo trạng thái, thời gian, mã yêu cầu',
    statusSection: 'Trạng thái',
    dateRangeSection: 'Thời gian tạo',
    hoaDonGocSection: 'Hóa đơn gốc',
    rejectSection: 'Lọc theo reject',
    allStatus: 'Tất cả trạng thái',
    daBiReject: 'Chỉ yêu cầu bị khách reject',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    presetHomNay: 'Hôm nay',
    presetTuanNay: 'Tuần này',
    presetThangNay: 'Tháng này',
    presetTuyChinh: 'Tùy chỉnh',
    resetFilter: 'Đặt lại bộ lọc',
  },
  placeholders: {
    searchMaYeuCau: 'Tìm theo mã yêu cầu...',
    searchQueue: 'Tìm kiếm',
    searchKhachHang: 'Tìm mã / tên khách hàng...',
    inputLyDoXuat: 'Nhập lý do xuất hóa đơn (vd: Xuất cho công ty A)',
    chonCongTy: 'Chọn công ty',
    chonTaiKhoan: 'Chọn số tài khoản',
    addHangHoa: 'Thêm hàng hóa vào yêu cầu...',
    writeComment: 'Viết bình luận...',
    inputLyDoReject: 'Nhập lý do khách không đồng ý (tùy chọn)',
    inputLyDoHuy: 'Nhập lý do hủy (không bắt buộc)',
    hoaDonGocId: 'UUID hóa đơn gốc',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    kyHieuHoaDon: 'VD: 1C26TAA',
    chonKhaiVat: '— Chọn dòng khai VAT —',
    chonHangHoa: 'Gõ mã / tên để tìm…',
    doiHangHoaHint: 'Bấm hoặc Enter — gõ mã/tên để tìm và chọn hàng',
    chuaCoKhaiVat: 'Chưa có thông tin VAT',
    khongTimThayHang: 'Không tìm thấy hàng hóa',
    khongTimThayKhaiVat: 'Không tìm thấy dòng khai VAT',
  },
  messages: {
    createAndGuiKtSuccess: 'Đã tạo yêu cầu {maYeuCau} và gửi kế toán.',
    createButGuiKtFailed: 'Đã tạo yêu cầu {maYeuCau} nhưng chưa gửi được kế toán: {reason}',
    listSummary: 'Tổng {count} yêu cầu',
    createSuccess: 'Đã tạo yêu cầu xuất hóa đơn {maYeuCau}.',
    yeuCauIntro:
      'Kiểm tra lại thông tin hàng hóa, đơn giá và người mua. Khi gửi, yêu cầu sẽ được tạo ở trạng thái "Mới tạo".',
    transitionSuccess: 'Đã chuyển trạng thái yêu cầu.',
    transitionFailed: 'Không thể chuyển trạng thái. Vui lòng làm mới trang và thử lại.',
    commentSuccess: 'Đã gửi bình luận.',
    commentEmpty: 'Vui lòng nhập nội dung bình luận.',
    commentFailed: 'Không thể gửi bình luận. Vui lòng thử lại.',
    uploadPdfSuccess: 'Đã tải lên hóa đơn nháp phiên bản v{n}.',
    uploadPdfFailed: 'Không thể tải lên file nháp. Vui lòng thử lại.',
    loadDetailFailed: 'Không thể tải chi tiết yêu cầu. Vui lòng thử lại sau.',
    loadingDetail: 'Đang tải chi tiết yêu cầu...',
    saving: 'Đang lưu...',
    noPermission: 'Bạn không có quyền thực hiện hành động này.',
    noTransition: 'Không có hành động nào khả dụng ở trạng thái này.',
    fileTooLarge: 'File vượt quá giới hạn 10MB.',
    fileInvalidType: 'Định dạng file không hợp lệ. Chỉ chấp nhận PDF, JPEG, PNG, Excel (xlsx/xls/csv).',
    chooseFile: 'Chọn file hoặc kéo thả vào đây (PDF/JPEG/PNG, tối đa 10MB)',
    validateBuyerInfoRequired:
      'Vui lòng nhập đủ 3 trường bắt buộc: mã số thuế, tên công ty lấy thuế, địa chỉ cty lấy thuế.',
    validateLyDoXuatRequired: 'Vui lòng nhập lý do xuất hóa đơn.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng xuất hóa đơn.',
    needKhachHang: 'Vui lòng chọn khách hàng.',
    khacKhachHang: 'Các hóa đơn đã chọn không cùng một khách. Một yêu cầu xuất hóa đơn chỉ được chung một khách.',
    needCompany: 'Mỗi mã hàng cần chọn công ty xuất hóa đơn.',
    validateLyDoHuyRequired: 'Vui lòng nhập lý do hủy.',
    updateBuyerSuccess: 'Đã cập nhật thông tin người mua.',
    updateBuyerFailed: 'Không cập nhật được thông tin người mua.',
    updateSuccess: 'Đã cập nhật yêu cầu xuất hóa đơn {maYeuCau}.',
    updateFailed: 'Không cập nhật được yêu cầu xuất hóa đơn.',
    doiTrangThaiSuccess: 'Đã chuyển trạng thái sang "{trangThai}".',
    xoaFileSuccess: 'Đã xóa file.',
    confirmXoaFile: 'Xóa file hóa đơn này?',
    coThayDoiChuaLuu: 'Có thay đổi chưa lưu',
    soSp: '{n} SP',
    chuaCoFile: 'Chưa có file',
    fileDropHint: 'Kéo thả, Ctrl+V hoặc bấm Chọn file · PDF, ảnh, Excel ≤10MB',
    clipboardKhongCoAnh: 'Clipboard không có ảnh. Hãy chụp/copy ảnh rồi bấm Dán ảnh.',
    uploadNhapSuccess: 'Đã tải lên {n} file hóa đơn nháp.',
    dangTaiLen: 'Đang tải lên...',
    emptyList: {
      heading: 'Chưa có yêu cầu xuất hóa đơn nào',
      body: 'Khi nhân viên bán hàng tạo yêu cầu xuất hóa đơn, danh sách sẽ hiển thị tại đây.',
    },
    emptyListFiltered: {
      heading: 'Không tìm thấy yêu cầu phù hợp',
      body: 'Thử bỏ bớt bộ lọc hoặc đặt lại để xem toàn bộ yêu cầu.',
    },
    emptyComments: 'Chưa có bình luận nào. Hãy để lại bình luận đầu tiên.',
    emptyFiles: 'Chưa có file hóa đơn nháp nào được tải lên.',
    emptyAuditLog: 'Chưa có lịch sử thay đổi.',
    emptyChiTietHangHoa: 'Chưa có chi tiết hàng hóa nào.',
    emptyThuKhac: 'Chưa có khoản thu khác nào.',
    rowCount: '{count} dòng',
    xuatHoaDonSuccess: 'Đã xuất hóa đơn cho yêu cầu {maYeuCau}.',
    uploadChinhThucSuccess: 'Đã đính kèm file hóa đơn chính thức.',
    emptyFilesChinhThuc: 'Chưa đính kèm file hóa đơn chính thức.',
    vuotTonKhaiVat: 'Số lượng xuất lớn hơn số lượng tồn khai VAT',
  },
  actions: {
    taoVaGuiKeToan: 'Tạo & gửi kế toán',
    create: 'Tạo yêu cầu xuất hóa đơn',
    send: 'Gửi yêu cầu',
    uploadDraft: 'Tải lên hóa đơn nháp',
    guiKeToan: 'Gửi kế toán',
    guiKhach: 'Gửi khách hàng',
    khachDongY: 'Khách đã đồng ý',
    khachKhongDongY: 'Khách không đồng ý',
    hoanThanh: 'Hoàn thành',
    huyYeuCau: 'Hủy yêu cầu',
    editBuyerInfo: 'Chỉnh sửa thông tin',
    saveBuyerInfo: 'Lưu thông tin',
    cancelEdit: 'Bỏ sửa',
    viewDetail: 'Xem chi tiết',
    writeComment: 'Viết bình luận',
    sendComment: 'Gửi bình luận',
    back: 'Quay lại',
    refresh: 'Làm mới',
    addLine: 'Thêm dòng trống',
    xuatHoaDon: 'Xuất hóa đơn',
    xacNhanXuatHoaDon: 'Xác nhận xuất hóa đơn',
    dinhKemHoaDonChinhThuc: 'Đính kèm hóa đơn chính thức',
    xoaFile: 'Xóa file',
    hoanTac: 'Hoàn tác',
    chonFileHd: 'Chọn file',
    danAnh: 'Dán ảnh',
    xuatExcelDaChon: 'Xuất Excel đã chọn',
    capNhatDaXuatHd: 'Đã xuất hóa đơn (đã chọn)',
  },
  bulk: {
    exportNeedSelect: 'Chọn ít nhất một yêu cầu để xuất Excel.',
    exportSuccess: 'Đã xuất Excel {count} yêu cầu.',
    exportSheetNguon: 'Chi tiết hàng hóa đơn',
    exportSheetXuatVat: 'Chi tiết hàng hóa',
    completeNeedSelect: 'Chọn ít nhất một yêu cầu ở trạng thái «Khách đồng ý».',
    completeConfirmTitle: 'Cập nhật đã xuất hóa đơn?',
    completeConfirmBody:
      'Đánh dấu {count} yêu cầu đã chọn sang trạng thái «Đã xuất hóa đơn». Số/ký hiệu HĐ (nếu có) được giữ nguyên; có thể bổ sung sau.',
    completeConfirm: 'Cập nhật',
    completeSuccess: 'Đã cập nhật {ok}/{total} yêu cầu.',
    completePartial: 'Cập nhật một phần: thành công {ok}, lỗi {fail}.',
    completeSkip: 'Bỏ qua {count} yêu cầu không ở trạng thái «Khách đồng ý».',
  },
  aria: {
    back: 'Quay lại danh sách',
    refresh: 'Làm mới chi tiết',
    uploadFile: 'Tải lên file hóa đơn nháp',
    sendComment: 'Gửi bình luận',
    viewDetailRow: 'Xem chi tiết yêu cầu',
    columnPicker: 'Chọn cột hiển thị',
    rejectBadge: 'Số lần khách không đồng ý',
    selectAllPage: 'Chọn tất cả dòng trên trang',
    selectRow: 'Chọn dòng',
  },
  detailTabs: {
    chiTiet: 'Thông tin',
    traoDoi: 'Trao đổi',
    lichSu: 'Lịch sử sửa',
  },
  expand: {
    rowClickExpand: 'Nhấn để mở rộng chi tiết',
  },
  confirm: {
    huyYeuCau: {
      title: 'Hủy yêu cầu xuất hóa đơn?',
      message:
        'Hành động này không thể hoàn tác. Yêu cầu sẽ được đánh dấu là đã hủy nhưng toàn bộ thông tin (buyer-info, comment, file nháp, lịch sử) vẫn được giữ lại để truy vết.',
      confirm: 'Hủy yêu cầu',
    },
  },
  trangThai: {
    MOI_TAO: 'Mới tạo',
    CHO_KT_XU_LY: 'Chờ KT xử lý',
    CHO_KHACH_DUYET: 'Chờ khách duyệt',
    KHACH_DONG_Y: 'Khách đồng ý',
    HOAN_THANH: 'Đã xuất hóa đơn',
    DA_HUY: 'Đã hủy',
  },
  auditActions: {
    CREATE_YCX: 'Tạo yêu cầu',
    GUI_KT: 'Gửi kế toán',
    GUI_KHACH: 'Gửi khách hàng',
    KHACH_DONG_Y: 'Khách đã đồng ý',
    KHACH_KHONG_DONG_Y: 'Khách không đồng ý',
    HOAN_THANH: 'Xuất hóa đơn',
    HUY: 'Hủy yêu cầu',
    UPLOAD_PDF: 'Tải lên file hóa đơn',
    CAP_NHAT_YCX: 'Cập nhật',
    DOI_TRANG_THAI: 'Đổi trạng thái',
  },
  audit: {
    xoaFile: 'Xóa file',
    trong: '(trống)',
  },
  xuatHoaDon: {
    intro:
      'Nhập số hóa đơn đã phát hành trên phần mềm hóa đơn điện tử cho từng hóa đơn (có thể bỏ trống và bổ sung sau). Sau khi xác nhận, yêu cầu chuyển sang "Đã xuất hóa đơn" — vẫn sửa lại được.',
  },
}
